import '../../scripts/domPolyfills/closest';
import { initAnchorNavigation } from '../../scripts/components/AnchorNavigation';

const SMART_SUBNAV_ITEM_ATTR = 'data-pro-pages-smart-subnav-nav-btn';

export function runProPagesSmartSubnav({
  intersectionThreshold,
  intersectionRatio,
}) {
  initAnchorNavigation(
    null,
    SMART_SUBNAV_ITEM_ATTR,
    intersectionThreshold,
    intersectionRatio,
    true
  );
}
